import React from 'react';
import { UserPayloadInput } from 'interface/createUpdateForm';
import { Role } from 'interface/role';
import { Skill } from 'interface/skill';
import { EmployeeLike } from 'interface/userUtils';

// Components

import FormWrapper from './forms/formWrapper';

// Constants

type AvailabilityInput = { value?: string; type?: string } | { hours: number; minutes: number };
type EmployeeFormValues = Omit<UserPayloadInput, 'availabilityStartTime' | 'availabilityEndTime'> & {
  availabilityStartTime?: AvailabilityInput;
  availabilityEndTime?: AvailabilityInput;
};

/** Dropdown rows from the API always include id + name (stricter than full Designation). */
type DesignationOption = { id: number; name: string };

interface EmployeeFormProps {
  formData: EmployeeFormValues;
  isCreateForm: boolean;
  employees: EmployeeLike[];
  designations: DesignationOption[];
  departments: Array<{ id: number; name: string }>;
  designationAreas: Array<{ id: number; name: string }>;
  engagementStatus: Array<{ id: number; name: string }>;
  skills: Skill[];
  canEdit: (key: string) => boolean;
  roles: Role[];
  empId?: number | string | null;
  handleSubmit: (values: EmployeeFormValues) => Promise<void> | void;
  isSubmitting: boolean;
}

const EmployeeForm: React.FC<EmployeeFormProps> = (props) => {
  const {
    formData,
    isCreateForm,
    employees,
    designations,
    departments,
    designationAreas,
    engagementStatus,
    skills,
    canEdit,
    roles,
    empId,
  } = props;

  const handleSubmit = (values: EmployeeFormValues) => props.handleSubmit(values);

  return (
    <FormWrapper
      initialFormData={formData}
      isSubmitting={props.isSubmitting}
      isCreateForm={isCreateForm}
      canEdit={canEdit}
      employees={employees}
      onSubmit={handleSubmit}
      designations={designations}
      departments={departments}
      designationAreas={designationAreas}
      engagementStatus={engagementStatus}
      skills={skills}
      roles={roles}
      empId={empId}
    />
  );
};

export default EmployeeForm;
